import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { LigneFinancementSecteur } from '../../model/ligneFinancement/ligneFinancementSecteur';

@Injectable({
  providedIn: "root"
})
export class LigneFinancementSecteurService {
  constructor(private _restClientService: RestClientService) {}

  getAllLigneFinancementSecteur() {
    return this._restClientService.load<LigneFinancementSecteur[]>(
      "ligne-financement-secteur/find-all"
    );
  }

  getById(id) {
    return this._restClientService.load<LigneFinancementSecteur>(
      "ligne-financement-secteur/find-by-id//" + id
    );
  }

  add(ligneFinancement) {
    return this._restClientService.save<LigneFinancementSecteur>(
      "ligne-financement-secteur/add",
      ligneFinancement
    );
  }

  update(ligneFinancement) {
    return this._restClientService.put<LigneFinancementSecteur>(
      `ligne-financement-secteur/update`,
      ligneFinancement
    );
  }

  delete(id) {
    return this._restClientService.delete<any>(
      "ligne-financement-secteur/delete/" + id
    );
  }
}
